/**
 * Created by mykurisu on 2017/8/21.
 */
import React from 'react'
import axios from 'axios'
import {connect} from 'react-redux'
import { getAccessToken } from '../../utils'
import { HTTPClient } from '@weike/toolkit'
import configEnv from '@src/config'
import weui from 'weui.js'
const HTTP_SUCCESS = '0000'
const http = new HTTPClient({baseURL: configEnv.BASE_URL_ELSE}, HTTP_SUCCESS)
class LecturerListItem extends React.Component {

    constructor() {
        super();
        this.state = {
            btnCanPress: true
        }
        this.handleHistoryClick = this.handleHistoryClick.bind(this);
        this.handleAddItem = this.handleAddItem.bind(this);
    }
    handlerSetSpeakerDialog = (content)=>{
      if(this.speakerId != content.id) {
        this.context.page.showConfirm('主讲人设置', '设为主讲人之后，该讲师可以进行开播并且原主讲人将会被移除', this.handlerSetSpeaker.bind(this, content));
      }
    }
    /**
     * 
     * @param {object} content 当前item 对象
     * @param {number} currentAccountId 移出时传入页面默认的account_id 设置为主讲人。
     */
    handlerSetSpeaker = (content, currentAccountId)=>{ // 设置主讲人，更新两个主讲人列表。
      const {lectureInfo: {id, liveroom_id}, type} = this.props;
      const getAccountId = currentAccountId || content.id
      return http.post('/v1/cont_api/syllabus_class.anchor.edit', {
        anchor_id: getAccountId,
        lecture_id: id,
        liveroom_id: liveroom_id,
        token: getAccessToken()
      }).then(res=>{
        const {code} = res
        if(code === HTTP_SUCCESS) {
          if(type === 'history') { // 为history列时，两列表需要有增减操作
            const list = [content];
            const totalList = this.props.currentList.filter(value => content.id !== value.id);
            this.props.dispatch({
              type: 'LECTURER_SELECTED_LIST',
              payload: list.concat(this.props.selectedList)
            });
            this.props.dispatch({
                type: 'LECTURER_INVITE_APPEND',
                payload: totalList
            })
          }
          this.props.dispatch({
              type: 'SET_SMALLCLASS_SPEAKER',
              payload: getAccountId
          })
        }
        return res
      })
    }
    handleNowClick(content) {
        if (this.state.btnCanPress){
            this.context.page.showConfirm('温馨提示', '是否移出此嘉宾', this.handleDeleteItem.bind(this, content));
        }
    }

    handleHistoryClick() {
        if (this.state.btnCanPress){
            this.context.page.showConfirm('温馨提示', '是否移入此嘉宾', this.handleAddItem);
        }
    }

    async handleDeleteItem(content) {
        const {speakerId, lectureInfo: {account_id}} = this.props
        // 移出列为当前主讲人时，需先重新设置主讲人为默认主讲人，再继续执行
        if(content.id === speakerId) {
          const res = await this.handlerSetSpeaker(content, account_id)
          if(res && res.code !== HTTP_SUCCESS) {
            weui.toast('操作失败', 3000)
            console.warn('设为主讲人失败，移出失败')
            return
          }
        }
        this.setState({
            btnCanPress: false
        });

        let data = new FormData();
        data.append('action', 'delete');
        data.append('account_id', this.props.content.id);
        axios.post(`/api/lecture/${this.props.urlData.target_id}/lecturer/manage`, data)
            .then(res => {
                if (res.data.code === 0){
                    this.setState({
                        btnCanPress: true
                    });
                    const selectedList = this.props.selectedList.filter(value => res.data.data.id !== value.id);
                    const totalList = [res.data.data];
                    this.props.dispatch({
                        type: 'LECTURER_SELECTED_LIST',
                        payload: selectedList
                    });
                    this.props.dispatch({
                        type: 'LECTURER_INVITE_APPEND',
                        payload: totalList.concat(this.props.currentList)
                    })
                }
            })
    }

    handleAddItem() {
        this.setState({
            btnCanPress: false
        });

        let data = new FormData();
        data.append('action', 'imported');
        data.append('account_id', this.props.content.id);
        axios.post(`/api/lecture/${this.props.urlData.target_id}/lecturer/manage`, data)
            .then(res => {
                if (res.data.code === 0){
                    this.setState({
                        btnCanPress: true
                    });
                    const list = [res.data.data];
                    const totalList = this.props.currentList.filter(value => res.data.data.id !== value.id);
                    this.props.dispatch({
                        type: 'LECTURER_SELECTED_LIST',
                        payload: list.concat(this.props.selectedList)
                    });
                    this.props.dispatch({
                        type: 'LECTURER_INVITE_APPEND',
                        payload: totalList
                    })
                }
            })
    }


    render() {
        const {type, content, lectureInfo, speakerId} = this.props;
        return (
            <div className="lecturer-listitem">
                <div className="listitem-left">
                    <div className="listitem-left-icon">
                        <img src={content.small_avatar_url} alt=""/>
                    </div>
                    <div className="listitem-left-name">
                        {content.nickname}
                    </div>
                </div>
                <div className="listitem-right">
                    { lectureInfo.image_mode === 'small_cls' && 
                      (<div className={`listitem-right-btn ${(type === 'now' && speakerId == content.id) ? 'current-speaker' : 'speaker'}`} onClick={this.handlerSetSpeakerDialog.bind(this, content)}>
                          {(type === 'now' && speakerId == content.id) ? '主讲人' : '设为主讲人'}
                      </div>)
                    }
                    <div className="listitem-right-btn" onClick={type === 'now' ?  this.handleNowClick.bind(this, content) : this.handleHistoryClick}>
                        {type === 'now' ? '移出' : '移入'}
                    </div>
                </div>
            </div>
        )
    }
}

LecturerListItem.contextTypes = {
    page: React.PropTypes.object,
};

export default connect(state => ({
    speakerId: state.lecturerInvite.speakerId,
    lectureInfo: state.lecturerInvite.lectureInfo,
    urlData: state.lecturerInvite.urlData,
    currentList: state.lecturerInvite.currentList,
    selectedList: state.lecturerInvite.selectedList
}))(LecturerListItem)


// WEBPACK FOOTER //
// ./src/components/lecturerInvite/LecturerListItem.js